import { render, staticRenderFns } from "./ProductDropdown.vue?vue&type=template&id=6a459cc6&scoped=true&"
import script from "./ProductDropdown.vue?vue&type=script&lang=ts&"
export * from "./ProductDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDropdown.vue?vue&type=style&index=0&id=6a459cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a459cc6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,AtomsRadioButton: require('/var/www/packages/theme/components/atoms/RadioComponent/RadioButton.vue').default,IconsChevronDownIcon24px: require('/var/www/packages/theme/components/icons/chevron-down/ChevronDownIcon24px.vue').default})
